export const sampleDistributionData = {
  nombre: "Activos",
  valor: 288,
  hijos: [
    {
      nombre: "Herramientas",
      valor: 80,
      color: "#34c759",
      hijos: [
        { nombre: "Excelente", valor: 40, color: "#34c759" },
        { nombre: "Bueno", valor: 25, color: "#30d158" },
        { nombre: "Regular", valor: 10, color: "#2ebd4e" },
        { nombre: "Necesita Reparación", valor: 5, color: "#27a640" }
      ]
    },
    {
      nombre: "Equipos Electrónicos",
      valor: 62,
      color: "#0071e3",
      hijos: [
        { nombre: "Excelente", valor: 25, color: "#0071e3" },
        { nombre: "Bueno", valor: 20, color: "#0062c3" },
        { nombre: "Regular", valor: 12, color: "#0054a6" },
        { nombre: "Necesita Reparación", valor: 5, color: "#004589" }
      ]
    },
    {
      nombre: "Mobiliario",
      valor: 45,
      color: "#ff9500",
      hijos: [
        { nombre: "Excelente", valor: 30, color: "#ff9500" },
        { nombre: "Bueno", valor: 10, color: "#e67e00" },
        { nombre: "Regular", valor: 5, color: "#cc6e00" },
        { nombre: "Necesita Reparación", valor: 0, color: "#b35f00" }
      ]
    },
    {
      nombre: "Equipos de Seguridad",
      valor: 28,
      color: "#ff2d55",
      hijos: [
        { nombre: "Excelente", valor: 15, color: "#ff2d55" },
        { nombre: "Bueno", valor: 8, color: "#e01d46" },
        { nombre: "Regular", valor: 3, color: "#c81a3e" },
        { nombre: "Necesita Reparación", valor: 2, color: "#b01736" }
      ]
    },
    {
      nombre: "Vehículos",
      valor: 38,
      color: "#5856d6",
      hijos: [
        { nombre: "Operativo", valor: 25, color: "#5856d6" },
        { nombre: "En Reparación", valor: 8, color: "#4a49c0" },
        { nombre: "Fuera de Servicio", valor: 5, color: "#3c3ca9" }
      ]
    },
    {
      nombre: "Equipo de Comunicación",
      valor: 18,
      color: "#5ac8fa",
      hijos: [
        { nombre: "Excelente", valor: 10, color: "#5ac8fa" },
        { nombre: "Bueno", valor: 5, color: "#4cb3e2" },
        { nombre: "Regular", valor: 2, color: "#419ec9" },
        { nombre: "Necesita Reparación", valor: 1, color: "#3789b0" }
      ]
    },
    {
      nombre: "Otros",
      valor: 17,
      color: "#af52de",
      hijos: [
        { nombre: "Excelente", valor: 7, color: "#af52de" },
        { nombre: "Bueno", valor: 5, color: "#9d47ca" },
        { nombre: "Regular", valor: 3, color: "#8b3eb4" },
        { nombre: "Necesita Reparación", valor: 2, color: "#79369f" }
      ]
    }
  ]
}; 